export default function validatePasswordStrength() {
  return (_, newValue: string | null): string | true => {
    const errorMessage = `
      Le mot de passe doit contenir 12 caractères dont des majuscules,
      des minuscules, des chiffres, des caractères spéciaux,
      ou plus de 20 caractères sans restriction
    `;
    if (newValue == null) return errorMessage;
    if (newValue.length > 20) return true;
    if (newValue.length < 12) return errorMessage;

    const specialCharacters = "!@#$€%^&*,.?\":;|<>_=+\\\\(\\\\)\\{\\}\\[\\]'-";
    const hasNumbers = /\d/.test(newValue);
    const hasLowerCaseLetters = newValue.toUpperCase() != newValue;
    const hasCapitalLetters = newValue.toLowerCase() != newValue;
    const hasSpecialCharacters = new RegExp(`[${specialCharacters}]`).test(
      newValue
    );
    const hasOnlyAuthorizedCharacters = new RegExp(
      `^[\\p{L}\\d${specialCharacters}]+$`,
      "gu"
    ).test(newValue);

    return (
      (hasNumbers &&
        hasLowerCaseLetters &&
        hasCapitalLetters &&
        hasSpecialCharacters &&
        hasOnlyAuthorizedCharacters) ||
      errorMessage
    );
  };
}
